angular
    .module('pipImageSlider', ['pipSliderButton', 'pipSliderIndicator', 'pipImageSlider.Service']);

import './ImageSlider';
import './ImageSliderService';
import './SliderButton';
import './SliderIndicator';

export * from './IImageSliderService';